import { alsZone } from '../lib/amsterdam'
import { eur } from '../lib/format'
import { nieuweAbonnee } from '../lib/panels'
import type { QueueRow } from '../lib/panels'

/**
 * 23-10-2026 (Jordy): "New subscriber – welcome him personally · €10.00 · Fri 23-10-2026 23:45"
 * (Amsterdamse tijd) zolang de fan na zijn betaalde abonnement nog geen persoonlijk
 * bericht van een chatter kreeg (max 24 uur; een automatisch platformbericht telt
 * niet). Een eigen, gevulde kleur: niet te verwarren met de spender-badge (oranje ★).
 * In de Waiting-rij en elke andere paneelregel, in All chats en in de chatkop.
 */
export function NieuweAbonneeTag({ c }: { c: QueueRow }) {
  if (!nieuweAbonnee(c)) return null
  const bedrag = c.new_paid_subscriber_amount != null ? ` · ${eur(Number(c.new_paid_subscriber_amount))}` : ''
  return (
    <span className="tag nieuwabo" data-testid="nieuwe-abonnee"
          title="New paid subscription and no personal message from a chatter yet. Thank this fan yourself. Disappears after a chatter's personal message or 24 hours after the payment. Time: Amsterdam.">
      New subscriber – welcome him personally{bedrag} · {alsZone(c.new_paid_subscriber_at)}
    </span>
  )
}
